import React, { lazy, Suspense, useEffect, useState } from "react";
import "./my-deposit-modal.scss";
import DefaultModal from "../DefaultModal";
import { useTranslation } from "react-i18next";
import { API_USER } from "../../../api/user";
import { useSelector } from "react-redux";
import { formatDateTime } from "../../../utils/utils";
import { successToast } from "../../mui/Toaster";
import { ENUM_DEPOSIT_STATUS, TEST_MODE } from "../../../store/enums";
import ShowContainer from "../../mui/ShowContainer";
import useDecimalValue from "../../../hooks/useDecimalValue";

const MyTable = lazy(() => import("../../mui/my_table/MyTable"));

const test = [
  { invoiceId: 1537, dateTime: "2025-12-15 08:27:07", refillAmount: "1705.75", status: 2 },
  { invoiceId: 1534, dateTime: "2025-12-15 08:27:07", refillAmount: "1705.75", status: 2 },
  { invoiceId: 14843, dateTime: "2025-09-19 10:19:53", refillAmount: "760.00", status: 9 }
];

export default function MyDepositModal({ isOpen, closeModal }) {
  const { t } = useTranslation();
  const getDecimalValue = useDecimalValue();

  const currency = useSelector((state) => state.user.currency);
  const [statusHash, setStatusHash] = useState({});
  const [deposits, setDeposits] = useState([]);
  const [depositLastDays, setDepositLastDays] = useState(0);

  const onCopyClick = (value) => {
    navigator.clipboard.writeText(value);
    successToast(t("successfully copied to clipboard"));
  };

  useEffect(() => {
    if (!isOpen) return;
    if (!currency) return;

    if (TEST_MODE) {
      setDeposits(test);
      setStatusHash({
        0: "any",
        1: "created",
        2: "paid",
        4: "expired",
        7: "inprocess",
        9: "failed",
        10: "unknown"
      });
      return;
    }

    API_USER.balance
      .depositList({ currency })
      .then((e) => {
        const data = e.data.data;
        setStatusHash(data.statusList);
        setDeposits(data.depositList);
        setDepositLastDays(data.options.depositLastDays);
        console.log(data);
      })
      .catch(console.log);
  }, [currency, isOpen]);

  const headers = [
    { accessor: "id", label: t("Invoice ID"), width: 100, type: "number" },
    {
      accessor: "dateTime",
      label: t("Date"),
      width: 140,
      type: "string"
    },
    {
      accessor: "refillAmount",
      label: t("Refill Amount"),
      width: "auto",
      type: "string"
    },
    {
      accessor: "status",
      align: "center",
      label: t("Status"),
      width: 110,
      type: "string"
    }
  ];

  const EMPLOYEE_DATA = deposits.map((el) => ({
    id: (
      <div className="copy-invoice pointer" onClick={() => onCopyClick(el.invoiceId)}>
        {el.invoiceId}
      </div>
    ),
    dateTime: formatDateTime(el.dateTime),
    refillAmount: `${getDecimalValue(el.refillAmount, currency)} ${currency}`,
    status: t(ENUM_DEPOSIT_STATUS[statusHash[el.status]])
  }));

  return (
    <DefaultModal isOpen={isOpen} closeModal={closeModal} classModal="my-deposit-modal">
      <h2>{t("Deposit transactions")}</h2>

      <ShowContainer condition={depositLastDays}>
        <p>{t("Shows all deposit requests for the last days.", { depositLastDays })}</p>
      </ShowContainer>

      <div className="table-scroller">
        <Suspense>
          <MyTable rows={EMPLOYEE_DATA} headers={headers} />
        </Suspense>
      </div>
    </DefaultModal>
  );
}
